<template>
  <div id="signup-modal" class="db relative center w-100">
    <div class="tc js-signup-container-modal center mw20rem-xs">
      <div class="flex flex-row items-center justify-around">
        <input type="email" class="dib h38px w-70 mv2 transparent-bg b--white-input is-white is-bebas br0 f5 fb100 tc css-text-input js-signup-input" v-model="submission.userEmail" placeholder="email@email.com" required />
        <a class="flex w-30 flex-row items-center justify-center center h38px mv2 btn-generic pointer js-signup-submit" @click="signupSubmit()" title="Email Signup Submit Button">
          <span class="text f5 ttu is-bebas is-white">
            signup
          </span>
        </a>
      </div>
      <div class="relative tc">
        <div class="db relative tc w-100 h-auto pv3">
          <span class="db absolute left-0 right-0 center tc is-white" v-if="successMessageIsVisible">
            Thanks for signing up!
          </span>
          <span class="db absolute left-0 right-0 center is-red" v-else-if="errorMessageIsVisible">
            Please enter a valid email
          </span>
          <span class="db absolute left-0 right-0 center o-0" v-else>
            None
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import AWS from 'aws-sdk/global';
  import Config from 'aws-sdk/clients/lambda';
  export default {
    components: {
      //
    },
    props: {
      //
    },
    data () {
      return {
        submission: {
          userEmail: ''
        },
        successMessageIsVisible: false,
        errorMessageIsVisible: false
      }
    },
    methods: {
      checkValidEmail(userEmail) {
        /*
        * Email Newsletter Signup email validation
        */
        if (userEmail !== undefined && /(.+)@(.+){2,}\.(.+){2,}/.test(userEmail)) {
          return true;
        }
        return false;
      },
      signupSubmit() {

        var userEmail = this.submission.userEmail.toLowerCase();

        if (this.checkValidEmail(userEmail) === true) {
          // fill in arn for lambda role and identity pool id
          var params = {
            AllowUnauthenticatedIdentities: true,
            RoleArn: "arn:aws:iam::290738313620:role/Cognito_mrIdPoolUnauth_Role", // Cognito unauth role
            IdentityPoolId: "us-east-1:c678b343-cffc-40ef-b65a-909d9e6fef9c" // the identity pool id found in Cognito
          };

          // set the Amazon Cognito region
          AWS.config.region = 'us-east-1';
          // initialize the Credentials object with our parameters
          AWS.config.credentials = new AWS.CognitoIdentityCredentials(params);

          // invoking the actual Lambda function
          var lambda = new AWS.Lambda();
          lambda.invoke(
            {
              FunctionName: 'mrEmailNewsletterSubscribe', // your function name
              LogType: "Tail",
              InvocationType: "Event",
              Payload: JSON.stringify({
                "email": userEmail,
                //"phone": userPhone
              }) // how you send the email to the Lambda event
            }, 
            function(err, data) {
              if (err) {
                console.log(err, err.stack);
              } 
              else {
                console.log('Thanks! You signed up to the Outside Lands email list: ', userEmail);
              }
            }
          );
          this.successMessageIsVisible = true;
        }
        else {
          this.errorMessageIsVisible = true;

        }
      }
    
    },
    mounted () {
      this.$nextTick(() => {
        /****************************
        DOC READY
        ****************************/
        //doc ready
        $(function() {
          //
        })
      });
    }
  }
</script>